import { render, staticRenderFns } from "./ym-feed.vue?vue&type=template&id=62a10c06&scoped=true&"
import script from "./ym-feed.vue?vue&type=script&lang=js&"
export * from "./ym-feed.vue?vue&type=script&lang=js&"
import style0 from "./ym-feed.vue?vue&type=style&index=0&id=62a10c06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a10c06",
  null
  
)

export default component.exports